require('./helpers/bundle-manifest').register(JSON.parse("{\"iEs1W\":\"index.a3a07c76.js\",\"ElxRc\":\"sprite.3707e4a3.svg\",\"b4XBm\":\"ru.efcca8ad.js\"}"));